import createSaga from './createSaga'
import listSaga from './listSaga'
import deleteSaga from './deleteSaga'
import otpSaga from './otpSaga'

const linkedInAccountSaga = [createSaga(), otpSaga(), listSaga(), deleteSaga()]

export default linkedInAccountSaga
